import { IPayload } from 'models/Global'
import { IGetUpshifterWorkHistoryParams, IUpshifterWorkHistory } from 'models/UpshifterWorkHistory'
import { AxiosService } from 'network/config/config'
import { Endpoints } from 'network/config/endpoints'

export class UpshifterWorkHistoryApi {
  constructor(private axios: AxiosService) {}

  getUpshifterWorkHistory = async (params?: IGetUpshifterWorkHistoryParams) => {
    const response = await this.axios.get<IPayload<IUpshifterWorkHistory[]>>(
      Endpoints.getUpshifterWorkHistory,
      params
    )
    return response
  }
}
